/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles, Tab, Tabs } from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import ApplicationState from 'store/interfaces';
import {
  CompanyData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import { ClientFields } from 'modules/clients/interfaces';
import Loading from 'components/Loading';
import ClientsTemplate from '../Templates/Clients';
import styles from './styles';
import DefaultApps from './defaultApps';
import WebClientApps from './webClientApps';

const useStyles = makeStyles(styles);

interface Props {
  permissions: PermissionsData | undefined;
  role?: RolesEnum;
  companySelected: CompanyData | null;
  client: ClientFields | null;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.tabPanelContent}
      hidden={value !== index}
      {...other}
    >
      {value === index && children}
    </div>
  );
};
const ApplicationsClients = ({
  permissions,
  role,
  companySelected,
  client,
}: Props) => {
  const classes = useStyles();

  const [currentTab, setCurrentTab] = React.useState(0);

  const configTabs = React.useMemo(
    () =>
      [
        {
          id: 'btn-default-apps',
          label: i18n.t('APPLICATIONS_PAGE.DEFAULT_APP_KEY'),
          hidden:
            !!permissions &&
            (client?.environment?.client_apps?.registration_source ===
            'platform'
              ? !permissions?.list_included_applications
              : !permissions?.list_applications),
          component: <DefaultApps />,
        },
        {
          id: 'btn-web-apps',
          label: i18n.t('APPLICATIONS_PAGE.WEB_CLIENT_APP_KEY'),
          hidden: !!permissions && !permissions?.list_web_applications,
          component: <WebClientApps />,
        },
      ].filter(tab => !tab.hidden),
    [permissions, role]
  );

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setCurrentTab(newValue);
  };

  const tabClasses = clsx({
    [classes.tabGray]: inSuperAdminView(role, companySelected),
    [classes.tabYellow]: companySelected,
  });

  const tabsClass = clsx({
    [classes.tabsGreen]: inAdminView(role, companySelected),
    [classes.tabsGray]: inSuperAdminView(role, companySelected),
    [classes.tabsBlue]: inOperatorView(role, companySelected),
    [classes.tabsYellow]: companySelected,
  });

  return (
    <ClientsTemplate
      current="applications"
      title={i18n.t('APPLICATIONS_PAGE.YOUR_APPLICATIONS_KEY')}
      breadcrumbs={[
        {
          name: i18n.t('CLIENT_KEY'),
          link: '/clients',
        },
        {
          name: i18n.t('APPLICATIONS_KEY'),
        },
      ]}
    >
      <Grid container className={classes.rootTabs}>
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          className={tabsClass}
        >
          {configTabs?.map((tab, index) => (
            <Tab
              key={index}
              id={tab?.id}
              label={tab?.label}
              className={tabClasses}
            />
          ))}
        </Tabs>
      </Grid>

      {client ? (
        <Grid container>
          {configTabs?.map((tab, index) => (
            <TabPanel key={index} value={currentTab} index={index}>
              {tab?.component}
            </TabPanel>
          ))}
        </Grid>
      ) : (
        <Loading />
      )}
    </ClientsTemplate>
  );
};

const mapStateToProps = ({
  clients: { isLoading, clientSelected },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  isLoading,
  companySelected,
  role: data?.role,
  client: clientSelected,
  permissions: data?.permissions,
});

export default connect(mapStateToProps, {})(ApplicationsClients);
